import React from "react";
import ReactDOM from "react-dom/client";
import "./Style/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { DadosUsuarioProvider } from "./providers/DadosDoUsuario";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <DadosUsuarioProvider>
        <App />
      </DadosUsuarioProvider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
